import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";

require("./Navigation.scss");
class Navigation extends Component {
  render() {
    
    return (
      <div className="nav-container">
            <Nav.Link as={Link} className="navigation-link" to="/subscription">
              <div className="navigation-title">Subscription Giving</div>
            </Nav.Link>
            <Nav.Link as={Link} className="navigation-link" to="/auction">
              <div className="navigation-title">Silent Auction</div>
            </Nav.Link>
            <Nav.Link as={Link} className="navigation-link" to="/shop-online">
              <div className="navigation-title">Shop Online</div>
            </Nav.Link>
            <Nav.Link as={Link} className="navigation-link" to="/resonate-exclusives">
              <div className="navigation-title">Resonate Exclusive</div>
            </Nav.Link>
            <Nav.Link as={Link} className="navigation-link" to="/tokens">
              <div className="navigation-title">Order History</div>
            </Nav.Link>
            <Nav.Link as={Link} className="navigation-link" to="/feedback">
              <div className="navigation-title">Feedback</div>
            </Nav.Link>
            <Nav.Link as={Link} className="navigation-link" to="/faq">
              <div className="navigation-title">FAQ'S</div>
            </Nav.Link>
      </div>
    );
  }
}

const mapStateToProps = state => {
  let count = state ? state.cartCount : 0;
  return { cartCount: count };
};

export default connect(mapStateToProps, null)(Navigation);
